import React from "react";

import { useTranslation } from "@opendash/core";
import { createComponent } from "@opendash/state";
import { AutoComplete } from "antd";
import { useMap } from "react-map-gl/maplibre";
import styled from "styled-components";
import { $geo } from "..";
import { AutocompleteResultType } from "../types";

type Props = {
  centerOnSelection?: boolean;
  onChange?(result: AutocompleteResultType): void;
};

const SearchBar = styled.div`
  position: absolute;
  top: 20px;
  left: 50px;
  right: 50px;
  z-index: 9999;

  > input,
  .ant-select {
    width: 100%;
  }
`;

export const Autocomplete = createComponent<Props>(function Autocomplete({
  onChange,
  centerOnSelection,
}) {
  const t = useTranslation();
  const { current: map } = useMap();

  const state = React.useMemo(() => $geo.createAutocomplete(), []);

  if (!state) {
    return null;
  }

  return (
    <SearchBar>
      <AutoComplete
        placeholder={t("opendash:ui.search_placeholder")}
        options={state.options}
        onSelect={(_: any, o: any) => {
          const result = o.result as AutocompleteResultType;

          if (onChange) {
            onChange(result);
          }

          if (map && centerOnSelection) {
            map.flyTo({
              center: {
                lat: result.latitude,
                lng: result.longitude,
              },
            });
          }
        }}
        onSearch={(search) => {
          state.setQuery(search);
        }}
      />
    </SearchBar>
  );
});
